import {Flex, Spin, theme, Typography} from 'antd';
import React from 'react';

const LogoutBackdrop = (props) => {
  const {token}: any = theme.useToken();

  return (
    <Flex
      vertical
      justify="center"
      align="center"
      gap={48}
      style={{
        position: 'absolute',
        height: '100vh',
        width: '100vw',
        zIndex: 9999,
        opacity: 0.9,
        backgroundColor: token.colorPrimaryBg,
      }}>
      <Spin size="large" />
      <Typography.Text>{props.text}</Typography.Text>
    </Flex>
  );
};

export default LogoutBackdrop;
